import React, { useCallback } from "react";
import { FormBuilder } from "../../../../components/form/FormBuilder";
import { forms } from "../../../../shared/static/forms";
import { store } from "../../../../redux/store";
import { hideModal } from "../../../../connected-components/modal/reducer";
import { addPatient } from "./actions";
import { AddPatientRequest } from "../../../../interfaces/api/patients";

const AddNewPatient: React.FC = () => {
  const handleSubmit = useCallback(async (value: Record<string, any>) => {
    const patientForm = {
      first_name: value.first_name,
      last_name: value.last_name,
      email: value.email,
      dob: value.dob,
      gender: value.gender,
      address: value.address,
      mobile_number: value.mobile_number,
      landline: value.landline,
      phone: value.phone,
      area: value.area,
      city: value.city,
      governorate: value.governorate,
      blood_type: value.blood_type,
      relationship: value.relationship || "Self",
      emergency_contact_name: value.emergency_contact_name || "N/A",
      emergency_contact_phone: value.emergency_contact_phone || "N/A",
      primary_language: value.primary_language || "Arabic",
      insurance_provider: value.insurance_provider || "None",
      insurance_number: value.insurance_number || "N/A",
      nssf_number: value.nssf_number || "N/A",
      ministry_health_card_number: value.ministry_health_card_number || "N/A",
    };
    const success = await addPatient(patientForm as AddPatientRequest);
    if (success) {
      store.dispatch(hideModal());
    }
  }, []);

  return (
    <div className="w-full pt-4">
      <FormBuilder
        schema={forms.addNewPatient}
        gridConfig={{ mobile: 1, desktop: 3 }}
        initialValues={{
          insurance_provider: "None",
          primary_insurance_type: "none",
          nationality: "Lebanese",
          preferred_currency: "USD",
          financial_class: "self_pay",
        }}
        onSubmit={handleSubmit}
      />
    </div>
  );
};

export default AddNewPatient;
